import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import AccountingSettingsForm from './components/AccountingSettingsForm';

const AccountingSettingsIndex = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Accounting Settings</h3>
        <h3 className="page-subhead subhead">
          <Link to="/">Home</Link> / Accounting Settings
        </h3>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <AccountingSettingsForm />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
);

export default AccountingSettingsIndex;
